package com.bikompanion.ui.home

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.composables.NoNetworkHereBanner
import com.bikompanion.ui.composables.ParkingCountdownIndicator
import com.bikompanion.ui.composables.ParkingLoadFailedBanner
import com.bikompanion.ui.composables.ParkingLoadingIndicator
import com.bikompanion.ui.composables.RefreshIndicator
import com.bikompanion.ui.composables.StationsLoadingIndicator
import com.bikompanion.ui.models.DataFreshness
import com.bikompanion.ui.models.ParkingCountdownStatus
import com.bikompanion.ui.models.RefreshStatus
import dev.chrisbanes.haze.HazeState
import com.bikompanion.ui.preview.GlassPreviewSurface

@Composable
internal fun HomeStatusColumn(
    refreshStatus: RefreshStatus,
    freshness: DataFreshness,
    parkingCountdownStatus: ParkingCountdownStatus,
    isLoadingStations: Boolean,
    showNoNetworkHere: Boolean,
    isLoadingParking: Boolean,
    showParkingLoadFailed: Boolean,
    onRetryLoadParkingClick: () -> Unit,
    hazeState: HazeState,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier) {
        RefreshIndicator(
            status = refreshStatus,
            freshness = freshness,
            hazeState = hazeState,
            modifier = Modifier.padding(bottom = 8.dp),
        )
        ParkingCountdownIndicator(
            status = parkingCountdownStatus,
            modifier = Modifier.padding(bottom = 8.dp),
        )
        StationsLoadingIndicator(
            isLoading = isLoadingStations,
            modifier = Modifier.padding(bottom = 8.dp),
        )
        NoNetworkHereBanner(
            isVisible = showNoNetworkHere,
            hazeState = hazeState,
            modifier = Modifier.padding(bottom = 8.dp),
        )
        ParkingLoadingIndicator(
            isLoading = isLoadingParking,
            modifier = Modifier.padding(bottom = 8.dp),
        )
        ParkingLoadFailedBanner(
            isVisible = showParkingLoadFailed,
            onRetry = onRetryLoadParkingClick,
        )
    }
}

@Preview
@Composable
private fun HomeStatusColumnPreview() {
    GlassPreviewSurface { hazeState ->
        HomeStatusColumn(
            refreshStatus = RefreshStatus.Waiting(secondsRemaining = 24),
            freshness = DataFreshness(),
            parkingCountdownStatus = ParkingCountdownStatus.Counting(secondsRemaining = 545),
            isLoadingStations = true,
            showNoNetworkHere = true,
            isLoadingParking = true,
            showParkingLoadFailed = true,
            onRetryLoadParkingClick = {},
            hazeState = hazeState,
            modifier = Modifier.padding(16.dp),
        )
    }
}
